module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    attrs: {
      "id": "gv-container"
    }
  }, [(_vm.showHeader) ? _vm._c('gv-header') : _vm._e(), _vm._v(" "), _vm._c('gv-map', {
    ref: "gv-map"
  }), _vm._v(" "), (_vm.showLegend) ? _vm._c('gv-legend', {
    ref: "gv-legend"
  }) : _vm._e(), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-tool-container"
  }, [_vm._c('div', {
    staticClass: "gv-tool-top gv-tool-left",
    attrs: {
      "id": "gv-tool-topleft"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-tool-top gv-tool-right",
    attrs: {
      "id": "gv-tool-topright"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-tool-bottom gv-tool-left",
    attrs: {
      "id": "gv-tool-bottomleft"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-tool-bottom gv-tool-right",
    attrs: {
      "id": "gv-tool-bottomright"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-335c5809!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 841
// module chunks = 39